import Vue from 'vue'
import App from './App.vue'
import router from './router'
import '@/assets/css/styles.css'
import VueGtag from 'vue-gtag'
import TranslationsData from '@/data/translations/translations.json'
import AdvertsData from '@/data/adverts/adverts.json'
import FieldConstant from '@/data/field-constants.json'

Vue.use(VueGtag, {
  config: {
    id: 'UA-205394668-1',
    enabled: false
  }
}, router)

// Grab our translations data and make it global.
Vue.prototype.$translations = TranslationsData
Vue.prototype.$adverts = AdvertsData
Vue.prototype.$fieldConstant = FieldConstant
Vue.config.devtools = true
Vue.config.productionTip = false

new Vue({
  data: {
    language: 'IEN',
    countryCodesArray: ['IEN', 'GB', 'FR', 'IT', 'HU', 'PL', 'NL', 'DE', 'ES', 'RU'],
    websiteCookiesArray: ['websiteCookies', 'abstractCookies', 'googleAnalyticsCookies'],
    savingsCostGlobal: '',
    savingsAmountGlobal: '',
    savingsPercentageGlobal: '',
    newApplicationCostGlobal: '',
    fieldSizeGlobal: '',
    implementGlobal: '',
    websiteCookies: '',
    abstractCookies: '',
    googleAnalyticsCookies: '',
    cookiePolicySelected: false,
    publicPath: process.env.BASE_URL,
    allowAllCookies: '',
    essentialCookiesOnly: ''
  },
  created: function () {
    // Check if our cookie policy was accepted
    this.websiteCookiesArray.forEach((cookie) => {
      if (document.cookie.split(';').some((item) => item.trim().startsWith(cookie))) {
        const cookiePolicyValue = document.cookie
          .split('; ')
          .find(row => row.startsWith(cookie))
          .split('=')[1]
        if (cookiePolicyValue === 'true') {
          this.$root[cookie] = true
        } else {
          this.$root[cookie] = false
        }
      }
    })

    // Set our language
    if (document.cookie.split(';').some((item) => item.trim().startsWith('language'))) {
      const languageValue = document.cookie
      .split('; ')
      .find(row => row.startsWith('language'))
      .split('=')[1]

      this.$root.language = languageValue
    }

    if (this.isBoolean(this.websiteCookies && this.isBoolean(this.abstractCookies) && this.isBoolean(this.googleAnalyticsCookies))) {
      this.$root.cookiePolicySelected = true
    }
    this.enableGoogleAnalytics()
    if (this.allCookiesTrue()) {
      this.$root.allowAllCookies = true
      this.$root.essentialCookiesOnly = false
    }
    if (this.allCookiesFalse()) {
      this.$root.allowAllCookies = false
      this.$root.essentialCookiesOnly = true
    }
    if (this.$root.googleAnalyticsCookies === true || this.$root.abstractCookies === true || this.$root.websiteCookies === true) {
      this.$root.essentialCookiesOnly = false
    }
    if (this.$root.googleAnalyticsCookies === false || this.$root.abstractCookies === false || this.$root.websiteCookies === false) {
      this.$root.allowAllCookies = false
    }
  },
  methods: {
    isBoolean (val) {
      if (typeof val === 'boolean') {
        return true
      } else {
        return false
      }
    },
    allCookiesTrue () {
      if (this.$root.googleAnalyticsCookies === true && this.$root.abstractCookies === true && this.$root.websiteCookies === true) {
        return true
      }
    },
    allCookiesFalse () {
      if (this.$root.googleAnalyticsCookies === false && this.$root.abstractCookies === false && this.$root.websiteCookies === false) {
        return true
      }
    },
    enableGoogleAnalytics () {
      if (this.$root.googleAnalyticsCookies === true) {
        window['ga-disable-UA-205394668-1'] = false
      } else {
        window['ga-disable-UA-205394668-1'] = true
      }
    },
    getImgUrl (image, extraUrl) {
      if (extraUrl) {
        var images = require.context('./assets/countries/', false, /\.png$/)
        return images('./' + image + '.png')
      } else {
        return require('@/assets' + image)
      }
    },
    automaticLanguageSelect () {
      // Check if the cookie already exists before make an API request.
      // Set the global language variable if it does exist.
      if (document.cookie.split(';').some((item) => item.trim().startsWith('language'))) {
        const languageCookieValue = document.cookie
          .split('; ')
          .find(row => row.startsWith('language'))
          .split('=')[1]
        // Check the value of the cookie is a valid ISO code.
        if (this.$root.countryCodesArray.includes(languageCookieValue)) {
          this.$root.language = languageCookieValue
          return
        }
        // Set default language and destroy the cookie if it's not a valid ISO country code / translation
        this.$root.language = 'IEN'
        document.cookie = 'language=; expires=Thu, 01 Jan 1970 00:00:00 UTC;'
        // We return here as we don't want to run the API request because we know the user
        // is from a country for which we have no translation.
        return
      }

      // Check the user has accepted to use their IP address.
      if (this.$root.abstractCookies === true) {
        var xhr = new XMLHttpRequest()
        var dataObject = { abstractCookies: this.$root.abstractCookies }

        xhr.open('POST', '/language-change-created', true) // true for asynchronous
        xhr.setRequestHeader('Accept', 'application/json; charset=UTF-8')
        xhr.setRequestHeader('Content-Type', 'application/json; charset=UTF-8')
        xhr.send(JSON.stringify({ dataObject, countryCodes: this.$root.countryCodesArray }))

        xhr.onreadystatechange = () => {
          if (xhr.readyState === 4 && xhr.status === 200) {
            // If our code exists in the translations then create the cookie and set the global variable.
            if (this.$root.countryCodesArray.includes(xhr.response)) {
              this.$root.language = xhr.response
            } else {
              // If not then we default to English.
              this.$root.language = 'IEN'
            }
          }
        }
      }
    }
  },
  router,
  render: h => h(App)
}).$mount('#app')